(function () {
    'use strict';

    const MOBILE_BREAKPOINT = 768;
    const ITEMS_PER_VIEW = 2;

    const sections = document.querySelectorAll('.confidence-badges');
    if (sections.length === 0) return;

    sections.forEach((section) => {
        const carousel = section.querySelector('[data-confidence-carousel]');
        const track = section.querySelector('.confidence-badges__track');
        const items = section.querySelectorAll('.confidence-badges__badge');
        const prevButton = section.querySelector('.confidence-badges__arrow--prev');
        const nextButton = section.querySelector('.confidence-badges__arrow--next');
        const progressBar = section.querySelector('.confidence-badges__progress-bar');
        const progressLine = section.querySelector('.confidence-badges__progress-line');

        if (!carousel || !track || items.length === 0) return;

        let currentIndex = 0;
        let totalSlides = 0;
        let maxIndex = 0;
        let touchStartX = 0;
        let touchEndX = 0;

        function isMobileCarousel() {
            return window.innerWidth < MOBILE_BREAKPOINT;
        }

        function getTrackGap() {
            const computedStyles = window.getComputedStyle(track);
            const gap = parseFloat(computedStyles.columnGap || computedStyles.gap || '0');
            return Number.isNaN(gap) ? 0 : gap;
        }

        function clearInlineItemSizes() {
            items.forEach((item) => {
                item.style.flexBasis = '';
                item.style.maxWidth = '';
                item.style.width = '';
            });
        }

        function updateSlideMetrics() {
            const totalItems = items.length;
            totalSlides = Math.ceil(totalItems / ITEMS_PER_VIEW);
            maxIndex = Math.max(0, totalSlides - 1);

            if (currentIndex > maxIndex) {
                currentIndex = maxIndex;
            }
        }

        function updateItemWidths() {
            const carouselWidth = carousel.offsetWidth;
            if (!carouselWidth) return;

            const gap = getTrackGap();
            const itemWidth = (carouselWidth - gap * (ITEMS_PER_VIEW - 1)) / ITEMS_PER_VIEW;
            const safeItemWidth = itemWidth > 0 ? itemWidth : carouselWidth / ITEMS_PER_VIEW;

            items.forEach((item) => {
                item.style.flexBasis = `${safeItemWidth}px`;
                item.style.maxWidth = `${safeItemWidth}px`;
                item.style.width = `${safeItemWidth}px`;
            });
        }

        function resetCarousel() {
            currentIndex = 0;
            track.style.transform = 'translateX(0)';
            clearInlineItemSizes();
            updateButtons();
            updateProgress();
        }

        function updateCarousel() {
            if (!isMobileCarousel()) {
                track.style.transform = 'translateX(0)';
                clearInlineItemSizes();
                return;
            }

            updateItemWidths();
            const gap = getTrackGap();

            if (items.length <= ITEMS_PER_VIEW) {
                track.style.transform = 'translateX(0)';
                return;
            }

            const carouselWidth = carousel.offsetWidth;
            // Advance by viewport width plus one gap so the next pair aligns without clipping the right edge.
            const pageStep = carouselWidth + gap;
            const translateX = -(currentIndex * pageStep);

            track.style.transform = `translateX(${translateX}px)`;
        }

        function updateProgress() {
            if (!isMobileCarousel() || totalSlides === 0 || items.length <= ITEMS_PER_VIEW) {
                if (progressBar) progressBar.style.width = '0%';
                if (progressLine) progressLine.style.width = '0%';
                return;
            }

            const progress = ((currentIndex + 1) / totalSlides) * 100;
            if (progressBar) progressBar.style.width = `${progress}%`;
            if (progressLine) progressLine.style.width = `${progress}%`;
        }

        function updateButtons() {
            const carouselActive = isMobileCarousel() && items.length > ITEMS_PER_VIEW;

            if (prevButton) {
                prevButton.disabled = !carouselActive || currentIndex === 0;
            }

            if (nextButton) {
                nextButton.disabled = !carouselActive || currentIndex >= maxIndex;
            }
        }

        function navigateCarousel(direction) {
            if (!isMobileCarousel() || items.length <= ITEMS_PER_VIEW) return;

            const newIndex = currentIndex + direction;

            if (newIndex < 0) {
                currentIndex = 0;
            } else if (newIndex > maxIndex) {
                currentIndex = maxIndex;
            } else {
                currentIndex = newIndex;
            }

            updateCarousel();
            updateProgress();
            updateButtons();
        }

        function handleTouchStart(e) {
            touchStartX = e.changedTouches[0].screenX;
        }

        function handleTouchEnd(e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }

        function handleSwipe() {
            if (!isMobileCarousel() || items.length <= ITEMS_PER_VIEW) return;

            const swipeThreshold = 50;
            const diff = touchStartX - touchEndX;

            if (Math.abs(diff) > swipeThreshold) {
                navigateCarousel(diff > 0 ? 1 : -1);
            }
        }

        function refresh() {
            updateSlideMetrics();

            if (!isMobileCarousel() || items.length <= ITEMS_PER_VIEW) {
                resetCarousel();
                return;
            }

            updateCarousel();
            updateProgress();
            updateButtons();
        }

        if (prevButton) {
            prevButton.addEventListener('click', () => navigateCarousel(-1));
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => navigateCarousel(1));
        }

        carousel.addEventListener('touchstart', handleTouchStart, { passive: true });
        carousel.addEventListener('touchend', handleTouchEnd, { passive: true });

        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(refresh, 250);
        });

        window.addEventListener('load', refresh);
        refresh();
    });
})();
